import { render, staticRenderFns } from "./CoozzyBadge.vue?vue&type=template&id=f25222ba&scoped=true"
import script from "./CoozzyBadge.vue?vue&type=script&lang=js"
export * from "./CoozzyBadge.vue?vue&type=script&lang=js"
import style0 from "./CoozzyBadge.vue?vue&type=style&index=0&id=f25222ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25222ba",
  null
  
)

export default component.exports